import UserRole from "../../../../../../common/types/user-role";
import userPermissionsService from "../../../../../../common/utils/user/permissions/user-permissions.service";
import BillingsTaxiOrderListingUserPermissionDefinition, {
  BillingsTaxiOrderListingUserPermissions,
} from "./billings-taxi-order-listing-user-permission";

const getPermissions = (
  userRoles: UserRole[]
): BillingsTaxiOrderListingUserPermissions => {
  return userPermissionsService.solvePermissions(
    userRoles,
    BillingsTaxiOrderListingUserPermissionDefinition
  );
};

const billingsTaxiOrderListingUserPermissionsHelper = {
  getPermissions,
};

export default billingsTaxiOrderListingUserPermissionsHelper;
